import { render, staticRenderFns } from "./selectPlan.vue?vue&type=template&id=fb16d348"
import script from "./selectPlan.vue?vue&type=script&lang=js"
export * from "./selectPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports